import { track } from '../misc/utils';

const onTap = (index) => state => {
  state.text.selected = index;
  return state;
};

let allowPanMove = true;

const onPanStart = (evt, index) => state => {
  const active = state.text.selected;

  if (active !== index) {
    allowPanMove = false;
  }
};

const onPanMove = evt => state => {
  if (!allowPanMove) {
    return state;
  }
  const index = state.text.selected;
  const selectedText = state.label.text[index];

  const x = selectedText.prevState.x + evt.deltaX;
  const y = selectedText.prevState.y + evt.deltaY;

  state.label.text[index].x = x;
  state.label.text[index].y = y;

  return state;
};

const onPanEnd = (evt, text) => state => {
  allowPanMove = true;

  const index = state.text.selected;
  const currentText = state.label.text[index];

  const prevState = {
    ...currentText,
    x: currentText.prevState.x,
    y: currentText.prevState.y
  };

  state.text.actions.push({
    type: "EDIT",
    target: index,
    prevState: { ...prevState }
  });

  state.label.text[index].prevState = {
    x: currentText.x,
    y: currentText.y
  };

  return state;
};

const setTextColour = (colour, index) => state => {
  if (index === null || index === undefined) {
    return;
  }

  const targetText = state.label.text[index];

  const prevState = {
    ...targetText,
    colour: targetText.colour
  };

  state.label.text[index].prevState = prevState;

  state.text.actions.push({
    type: "EDIT",
    target: index,
    prevState: { ...prevState }
  });

  state.label.text[index].colour = colour;
  return state;
};

const setTextFamily = (fontFamily, index) => state => {
  if (index === null || index === undefined) {
    return;
  }

  const targetText = state.label.text[index];

  const prevState = {
    ...targetText,
    fontFamily: targetText.fontFamily
  };

  state.label.text[index].prevState = prevState;

  state.text.actions.push({
    type: "EDIT",
    target: index,
    prevState: { ...prevState }
  });

  state.label.text[index].fontFamily = fontFamily;
  return state;
};

const editText = (text, index) => state => {
  const targetText = {...state.label.text[index]};

  const prevState = {
    ...targetText,
    value: targetText.value
  };

  state.label.text[index].prevState = prevState;

  state.text.actions.push({
    type: "EDIT",
    target: index,
    prevState: { ...prevState }
  });

  targetText.value = text;
  state.label.text[index] = targetText;
  return state;
};

let textTimerStart = null;

const setTextSize = (fontSize, index, callback) => state => {
  if (index === null || index === undefined) {
    return;
  }

  textTimerStart = new Date().getTime();

  setTimeout(() => {
    if (
      callback &&
      textTimerStart &&
      textTimerStart - new Date().getTime() < 500
    ) {
      textTimerStart = null;
      callback.call(null, index);
    }
  }, 500);

  state.label.text[index].fontSize = +fontSize;
  return state;
};

const pushTextSizeAction = index => state => {
  const targetText = state.label.text[index];

  state.text.actions.push({
    type: "EDIT",
    target: index,
    prevState: { ...targetText, fontSize: targetText.prevState.fontSize }
  });

  state.label.text[index].prevState.fontSize = targetText.fontSize;
  return state;
};

const bringToFront = index => state => {
  track.event('button', 'click', 'text_front');
  if (index === null || index === undefined) {
    return;
  }

  if (state.label.text[index].zIndex === state.maxZIndex) {
    return;
  }

  const targetText = state.label.text[index];

  const prevState = {
    ...targetText.prevState,
    zIndex: targetText.zIndex
  };

  state.label.text[index].prevState = prevState;

  state.text.actions.push({
    type: "EDIT",
    target: index,
    prevState: { ...prevState }
  });

  state.maxZIndex += 1;
  state.label.text[index].zIndex = state.maxZIndex;
  return state;
};

const deleteText = index => state => {
  if (index === null || index === undefined) {
    return;
  }

  state.label.text[index].skip = true;
  state.text.selected = null;
  state.text.actions.push({
    type: "DELETE",
    target: index
  });

  return state;
};

const handleUndo = () => state => {
  if (state.text.actions.length < 1) {
    track.event('button', 'click', 'text_undo');
    return;
  }

  const latestAction = state.text.actions.pop();
  track.event('button', 'text_undo', latestAction.type);

  switch (latestAction.type) {
    case "EDIT":
      state.label.text[latestAction.target].x = latestAction.prevState.x;
      state.label.text[latestAction.target].y = latestAction.prevState.y;
      state.label.text[latestAction.target].zIndex =
        latestAction.prevState.zIndex;
      state.label.text[latestAction.target].fontFamily =
        latestAction.prevState.fontFamily;
      state.label.text[latestAction.target].fontSize =
        latestAction.prevState.fontSize;
      state.label.text[latestAction.target].colour =
        latestAction.prevState.colour;
      break;
    case "DELETE":
      state.label.text[latestAction.target].skip = false;
      break;
    default:
      break;
  }

  return state;
};

export const textActions = {
  onTap,
  onPanMove,
  onPanStart,
  onPanEnd,
  setTextColour,
  setTextFamily,
  setTextSize,
  pushTextSizeAction,
  bringToFront,
  deleteText,
  handleUndo,
  editText
};



// WEBPACK FOOTER //
// ./src/actions/text.js